module.exports = "/images/tz.svg?d368783384bc0a41abc3623aa872af01";